(() => {
  document.querySelectorAll('[data-oe-language]').forEach(select => select.addEventListener('change', () => {
    try { localStorage.setItem('orevyr_language_choice', select.value); } catch (_) {}
    select.form.requestSubmit();
  }));
  const menu = document.querySelector('.or-header__menu');
  if (!menu) return;
  const trigger = menu.querySelector('summary');
  menu.addEventListener('toggle', () => {
    document.body.classList.toggle('oe-menu-open', menu.open);
    if (menu.open) menu.querySelector('a,select,button')?.focus();
    else trigger?.focus();
  });
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; event.preventDefault(); return; }
    if (event.key !== 'Tab' || !menu.open) return;
    const items = [...menu.querySelectorAll('summary,a,select,button')].filter(el => el.getClientRects().length);
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
